import { FC, useState } from "react";
import { Box, FormControlLabel, Grid, Switch, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SCUIButton } from "../../../../atomic/atoms";
import { SCUIGeneralDrawerHeader } from "../../../../atomic/molecules";

import { ETBED_PARAM, etbCls } from "../../emailTemplateBuilder.classes";

interface IProps {
  onClose?: any;
  setGeneratedParameterValue?: any;
}
export const AddOrEditParameterDrawer: FC<IProps> = ({
  onClose,
  setGeneratedParameterValue,
}) => {
  const { t } = useTranslation();
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [textFieldValue, setTextFieldValue] = useState("");

  const handleSwitchChange = (event: any) => {
    setIsSwitchOn(event.target.checked);
  };

  const handleTextFieldChange = (event: any) => {
    setTextFieldValue(event.target.value);
  };

  const generateText = () => {
    if (isSwitchOn) {
      return `[*${textFieldValue}]`;
    } else {
      return `[${textFieldValue}]`;
    }
  };

  const handleAddButton = () => {
    let text = generateText();
    setGeneratedParameterValue(text);
  };

  return (
    <form
      onSubmit={(e: any) => {
        e.preventDefault();
      }}
    >
      <div
        className={etbCls(
          "emailTemplateAddParameterContainer",
          ETBED_PARAM.shell
        )}
        style={{ padding: "1rem" }}
      >
        {
          <Grid container spacing={1}>
            <SCUIGeneralDrawerHeader
              header={t("emailTemplateBuilder.addParameter")}
              onClose={onClose}
            />
            <Grid
              size={{
                xs: 12,
                md: 12,
                lg: 12,
                xl: 12
              }}>
              <Grid
                className={ETBED_PARAM.fieldKeywordSwitch}
                style={{ marginTop: "2rem" }}
                size={{
                  xs: 12,
                  md: 12,
                  lg: 12,
                  xl: 12
                }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={isSwitchOn}
                      onChange={handleSwitchChange}
                    />
                  }
                  label={t("emailTemplateBuilder.keywordIsRequired")}
                />
                <Box className={ETBED_PARAM.fieldParameterText}>
                <TextField
                  className={ETBED_PARAM.inputTextfieldParameter}
                  label={t("emailTemplateBuilder.addParameter")}
                  variant="outlined"
                  fullWidth
                  value={textFieldValue}
                  onChange={handleTextFieldChange}
                />
                </Box>
              </Grid>
            </Grid>
            <Grid
              className={ETBED_PARAM.spacerGrid}
              container
              spacing={1}
              sx={{ minHeight: { xs: 250, lg: 450 }, paddingBottom: "1rem" }}
            ></Grid>
            <Grid
              className={ETBED_PARAM.actionsFooter}
              style={{
                position: "absolute",
                bottom: 0,
                width: 380,
                marginBottom: "20px",
              }}>
              <SCUIButton
                className={ETBED_PARAM.inputButtonAdd}
                text={t("general.add")}
                type="primary"
                sizeType="default"
                buttonType="submit"
                size={"s"}
                fullwidth
                onClick={handleAddButton}
              />
            </Grid>
          </Grid>
        }
      </div>
    </form>
  );
};
